import React from "react";
import { Grid, Typography, TextField, Box } from "@mui/material";
import colors from "../../Constants/colors";

const textFieldStyles = {
  width: "220px",
  "& .MuiInputLabel-root": {
    color: colors.primary_dark,
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: colors.primary_dark,
    },
    "&:hover fieldset": {
      borderColor: colors.primary_dark,
    },
    "&.Mui-focused fieldset": {
      borderColor: colors.primary_dark,
    },
    "& input": {
      color: colors.primary_dark,
    },
  },
};

const colorBoxStyles = (backgroundColor: string) => ({
  width: "40px",
  height: "40px",
  borderRadius: "50%",
  backgroundColor,
  border: `1px solid ${colors.primary_dark}`,
});

interface ColorPickerFieldProps {
  label: string;
  value: string;
  onFocus: () => void;
  onChange: (newColor: string) => void;
}

const ColorPickerField: React.FC<ColorPickerFieldProps> = ({
  label,
  value,
  onFocus,
  onChange,
}) => (
  <Grid item sx={{ marginBottom: "1rem" }}>
    <Typography
      sx={{
        color: colors.primary_dark,
        fontWeight: "bold",
        marginBottom: "0.5rem",
      }}
    >
      {label}:
    </Typography>
    <Grid container alignItems="center" spacing={2}>
      <Grid item>
        <TextField
          value={value}
          onFocus={onFocus}
          onChange={(e) => onChange(e.target.value)}
          variant="outlined"
          size="small"
          InputLabelProps={{
            style: { color: colors.primary_dark, fontSize: "14px" },
          }}
          sx={textFieldStyles}
        />
      </Grid>
      <Grid item>
        <Box
          sx={{ ...colorBoxStyles(value), cursor: "pointer" }}
          onClick={onFocus}
        />
      </Grid>
    </Grid>
  </Grid>
);

export default ColorPickerField;
